
import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Image, Grid, Dropdown, List, Label, Popup, Checkbox } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { API_URL } from '../App.js';
import axios from 'axios';
import { TagColors, legenddict } from './SearchHelper.js';
// import {retrieveSubjectObject, nounoptions1, nounoptions2, nounoptions3, nounoptionsmodalis, options1, options2, options3, verbPostbases, nounPostbases} from './constants/constants.js'
// import {postbasesEndingsUnderlying} from './constants/underlying.js'
// import palette from 'google-palette';
// import shuffle from 'shuffle-array';
// import { TagColors } from './HomeHelper.js';
import * as Scroll from 'react-scroll';
import ReactGA from "react-ga4";
ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;
let customFontFam = "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif"




class Report extends Component {
	constructor(props) {
		// console.log(props)
		super(props);
		this.state = {
			// history: props.location.state === undefined ? [] : props.location.state.history,
			// from: props.location.state === undefined ? '' : props.location.state.from,
		}	   
		scroll.scrollTo(0);

	}


	render() {
		// console.log(this.state)
		// console.log(this.state.colorsList)

		return (
			<div style={{fontFamily:customFontFam}}>


			<Grid textAlign='center'>
		      <Grid.Row style={{maxWidth: 860, paddingBottom:0}}>
		        <Grid.Column textAlign='left'>
					<Link to={{pathname: "/search", state: { history:this.state.history, homeMode:0 }}} >
			          	<Button basic style={{paddingLeft:'10px',paddingRight:'15px',marginLeft:'3px'}} icon='left chevron' content='Back to Search' />
			        </Link>
		        </Grid.Column>
		      </Grid.Row>
		      <Grid.Row>
		        <Grid.Column style={{maxWidth: 860, paddingBottom:0}}>
					<div style={{border:'1px solid #E3E3E3',marginTop:'14px'}}>
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2'>Parts of Speech Legend</span>
							</div>
						</div>
							{window.innerWidth < 480 ?
								<div>
									{Object.keys(legenddict).map((k)=>
										<div style={{textAlign:'left',padding:5}}>
											<span>
							                  <TagColors tags={k} size='medium' width={-1} />
							                </span>
							                <span style={{fontWeight:'500',marginLeft: 10}}>
							                	{legenddict[k][0]}
							                </span>
							                <div style={{padding:15}}>
								                <div style={{paddingBottom:8}} dangerouslySetInnerHTML={{__html: legenddict[k][1]}} />
								                <div style={{fontWeight:'300'}} dangerouslySetInnerHTML={{__html: legenddict[k][2]}} />
								            </div>
								        </div>
									)}
								</div>
								:
								<Grid textAlign='left'>
									{Object.keys(legenddict).map((k)=>
										<Grid.Row style={{margin:10,paddingBottom:0}} columns={3}>
											<Grid.Column width={3}>
							                  <TagColors tags={k} size='medium' width={-1} />
							                </Grid.Column>
							                <Grid.Column style={{fontWeight:'500'}} width={3}>
							                	{legenddict[k][0]}
							                </Grid.Column>
							                <Grid.Column width={10}>
								                <div style={{paddingBottom:8}} dangerouslySetInnerHTML={{__html: legenddict[k][1]}} />
								                <div style={{fontWeight:'300'}} dangerouslySetInnerHTML={{__html: legenddict[k][2]}} />
								            </Grid.Column>
								        </Grid.Row>
									)}
								</Grid>
							}
					</div>
		        </Grid.Column>
		      </Grid.Row>
			</Grid>

			</div>
		);
	}
}
export default Report;
